
    var riot = require('riot')
    
riot.tag2('siemens-register', '<div if="{showform &amp;&amp; !opts.type}"> <div name="registerform" class="page-form"> <div class="row"> <div class="col-xs-12 col-sm-6"> <label for="first_name">Name</label> <input name="first_name" data-val="true" placeholder="Name" type="text" value="{user.first_name ? user.first_name+\' \'+user.surname : \'\'}" required> </div> <div class="col-xs-12 col-sm-6"> <label for="Email">Email</label> <input name="email" data-val="true" placeholder="Email" type="text" value="{user.email}" required> </div> </div> <div class="row"> <div class="col-xs-12 col-sm-6"> <label for="company">Company</label> <input name="company" data-val="true" placeholder="Company" type="Company" value="{user.org_name}" required> </div> <div class="col-xs-12 col-sm-6"> <label for="phone1">Number</label> <input name="phone1" data-val="true" placeholder="Number" type="text" value="{user.phone1}" required> </div> </div> <div class="row"> <div class="col-xs-12 text-center"> <button onclick="{register}" if="{!opts.type}" class="btn btn-submit-form">GET FREE GUIDE</button> <button onclick="{sendform}" if="{opts.type==\'consultation\'}" class="btn btn-submit-form">BOOK FREE CONSULTATION</button> </div> </div> <div if="{signup_error}" class="alert alert-danger">{signup_error}</div> <div if="{signup_message}" class="alert alert-success">{signup_message}</div> </div> </div> <div if="{showform &amp;&amp; opts.type==\'consultation\'}"> <form method="POST" action="/duocms/api/formsend" class="page-form"> <input type="hidden" name="_csrf" value="{csrf_token}"> <input type="text" name="duoreform{duoreform}" value="" style="display: none;"> <input type="hidden" name="_sendto" value="Chris"> <div class="row"> <div class="col-xs-12 col-sm-6"> <label for="Name">First name</label> <input name="Name" placeholder="Name" type="text" value="{user.first_name ? user.first_name+\' \'+user.surname : \'\'}" required> </div> <div class="col-xs-12 col-sm-6"> <label for="Email">Email</label> <input id="Email" name="email" placeholder="Email" type="text" value="{user.email}" required> </div> </div> <div class="row"> <div class="col-xs-12 col-sm-6"> <label for="Company">Company</label> <input id="Company" name="company" placeholder="Company" type="Company" value="{user.org_name}" required> </div> <div class="col-xs-12 col-sm-6"> <label for="Number">Number</label> <input id="Number" name="telephone" placeholder="Number" type="text" value="{user.phone1}" required> </div> </div> <div class="row"> <div class="col-xs-12 text-center"> <button type="submit" class="btn btn-submit-form">Book Free Consultation</button> </div> </div> </form> </div>', '', '', function(opts) {
var orgsApi, resource, usersApi;

resource = require('riot-kit/utils/apiResource.coffee');

usersApi = new resource('/duocms/api/users/', true);

orgsApi = new resource('/duocms/api/orgs/', true);

this.duoreform = Math.round((4872987492 + new Date().getTime()) / 1000);

this.csrf_token = window.csrf;

this.on('mount', function() {
  if (!window.location.search.match(/editmode/)) {
    this.showform = true;
    if (this.opts.type === "consultation") {
      this.getuser();
    }
  }
  return this.update();
});

this.getuser = (function(_this) {
  return function() {
    return usersApi.get({
      id: "me"
    }, function(data) {
      console.log("getting user data", data);
      _this.user = data;
      if (_this.user.org_id) {
        _this.getorg(data.org_id);
      } else {
        _this.user.org_name = data.address;
      }
      return _this.update();
    });
  };
})(this);

this.getorg = (function(_this) {
  return function(org_id) {
    console.log("getting org data");
    return orgsApi.get({
      id: org_id
    }, function(orgdata) {
      _this.user.org_name = orgdata.name;
      return _this.update();
    });
  };
})(this);

this.register = (function(_this) {
  return function() {
    var data, fname, sname, splitname;
    _this.signup_error = null;
    if (!_this.first_name.value || !_this.email.value || !_this.company.value || !_this.phone1.value) {
      _this.signup_error = "You have not completed all form fields";
      setTimeout((function() {
        return _this.signup_error = null;
      }), 3000);
      return;
    }
    splitname = _this.first_name.value.split(" ");
    fname = _this.first_name.value;
    sname = "";
    if (splitname.length > 1) {
      fname = splitname[0].toString() || "";
      sname = splitname[1].toString() || "";
    }
    data = {
      first_name: fname,
      surname: sname,
      username: _this.email.value,
      email: _this.email.value,
      address: _this.company.value,
      phone1: _this.phone1.value
    };
    return _this.xhr("POST", "/duocms/api/register", data, function(res) {
      var message, ref;
      if (res.status === 200) {
        message = "You should have received an email from us. Click on the link in that email to activate your account.";
        _this.signup_message = message;
      } else if ((ref = res.body) != null ? ref.message : void 0) {
        _this.signup_error = res.body.message;
        setTimeout((function() {
          return _this.signup_error = null;
        }), 3000);
      } else {
        _this.signup_error = "Signup failed, please try again";
        setTimeout((function() {
          return _this.signup_error = null;
        }), 3000);
      }
      return _this.update();
    });
  };
})(this);

this.xhr = (function(_this) {
  return function(method, url, data, cback) {
    var xhr;
    xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.setRequestHeader("x-csrf-token", window.csrf);
    xhr.onreadystatechange = function() {
      var res;
      if (xhr.readyState === 4) {
        try {
          res = JSON.parse(xhr.responseText);
        } catch (error) {
          res = "";
        }
        return cback({
          status: xhr.status,
          body: res
        });
      }
    };
    return xhr.send(JSON.stringify(data));
  };
})(this);
});
    
  